import React from 'react';
import { SettingsIcon, MailIcon } from 'lucide-react';
import { Accordion } from './Accordion';
import { OBJECTIONS, SUPPORT_EMAIL } from '../data/content';
export function Objections() {
  return <section className="px-5 py-10" data-id="element-191" data-mp="mjfycbxmpquj">
      <div className="mx-auto max-w-md" data-id="element-192" data-mp="miedjfqt9pzm">
        <h2 className="text-center font-anton text-2xl leading-tight text-white" data-id="element-193" data-mp="hkuw66ytgx3g">
          ¿Todavía tienes dudas? Te las resolvemos
        </h2>

        <div className="mt-6 space-y-3" data-id="element-194" data-mp="cml2k0sqq4jy">
          {OBJECTIONS.map((o, i) => <Accordion key={i} emoji="❓" title={o.q} data-id="element-195" data-mp="7utd5tlbm4ve" data-mpi={i}>
              <p className="text-[14px] leading-snug text-neutral-300" data-id="element-196" data-mp="7t8djpk5fvqo">{o.a}</p>
            </Accordion>)}
        </div>

        {/* Support */}
        <div className="mt-8 flex flex-col items-center gap-2 rounded-xl border border-white/10 bg-[#111]/90 p-5 text-center" data-id="element-197" data-mp="3v0u3jzrlfr1j">
          <SettingsIcon className="h-8 w-8 text-[#F5C518]" data-id="element-198" data-mp="3pzwmjqibl31m" />
          <p className="text-sm text-neutral-400" data-id="element-199" data-mp="3l2mlfdlkj2xy">
            Atención y ayuda con tu compra
          </p>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="inline-flex items-center gap-2 font-oswald text-base font-600 text-white hover:text-[#F5C518]" data-id="element-200" data-mp="fz48htt486t">
            <MailIcon className="h-4 w-4" data-id="element-201" data-mp="3mp0646lmlix4" />
            {SUPPORT_EMAIL}
          </a>
        </div>
      </div>
    </section>;
}